// ============================================================================
// AppMode — режим работы приложения (как в 1С: Конфигуратор / Предприятие).
//
// ДЕТЕРМИНИРОВАННО по типу клиента и базе (SSoT):
//   - Desktop (Wails bridge) — режим настраивается (persist), переключатель виден.
//   - Web/PWA в ОПУБЛИКОВАННОЙ базе — режим ЗАБЛОКИРОВАН в 'enterprise'
//     (переключатель скрыт, setMode игнорируется; конфигуратор и на сервере 403).
//   - Web/PWA в НЕопубликованной базе — режим настраивается (админ работает
//     через браузер: конфигуратор доступен).
// Блокировка управляется setLocked (вызывается при выборе базы / выходе).
// ============================================================================

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type AppMode = 'enterprise' | 'configurator';

// Тип клиента определяется один раз при инициализации (без window.go — web/PWA)
export function isWebClient(): boolean {
  return typeof window !== 'undefined' && !(window as any).go?.main?.App?.OpenBase;
}

interface AppModeState {
  mode: AppMode;
  /** true — режим зафиксирован (web в опубликованной базе): переключатель скрыт */
  locked: boolean;
  setMode: (mode: AppMode) => void;
  toggleMode: () => void;
  setLocked: (locked: boolean) => void;
}

const webClient = isWebClient();

export const useAppModeStore = create<AppModeState>()(
  persist(
    (set, get) => ({
      // Web: стартуем в Предприятии; в неопубликованной базе админ переключится сам
      mode: (webClient ? 'enterprise' : 'configurator') as AppMode,
      locked: webClient,
      setMode: (mode) => {
        if (get().locked) return;
        set({ mode });
      },
      toggleMode: () => {
        if (get().locked) return;
        set({ mode: get().mode === 'configurator' ? 'enterprise' : 'configurator' });
      },
      setLocked: (locked) => set({ locked }),
    }),
    {
      name: 'hydra-app-mode',
      // locked НЕ персистится — вычисляется каждый раз при выборе базы
      partialize: (state) => ({ mode: state.mode }),
    }
  )
);
